import "scripts/resize_form_image"
import "scripts/filtered_table"
import { APP_NAME, pathArr, VIEW_NAME } from "scripts/router";
import SlipItemList from 'scripts/stocker/SlipItemList.svelte';
let app = undefined


if (APP_NAME === 'back-office' && VIEW_NAME == 'stocker' && pathArr[2] == 'detail') {
    app = new SlipItemList({
        target: document.querySelector('.sv-component')!,
    });
}

export default app;